import React, { useState } from "react";
import { Form, Input, Select, Upload } from "antd";
import SelectAddress from "../SelectAddress";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import Button from "../../atoms/Button";
import { Country, State, City } from "country-state-city";
import { useSelector } from "react-redux/es/hooks/useSelector";
import RegistryDetails from "../../organisms/KycForm/RegistryDetails";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import { motion } from "framer-motion";
import UploadIcon from "../../svgs/upload.svg";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { useDispatch } from "react-redux";
import { emailotpRequest } from "../../../utils/API/emailOTPrequest";
import { verifyOtp } from "../../../utils/API/verifyOtp";

const { TextArea } = Input;
const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf"
];
const BasicInformationForm = ({
  Country,
  form,
  registries,
  documents,
  setDocuments,
  shortDescription = false,
  isDisabledForm
}) => {
  const { userType } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  let countries = Country.getAllCountries();
  const [loading, setLoading] = useState(false);

  const [isCodeSent, setCodeSent] = useState(false);
  const [inputCode, setInputCode] = useState("");
  const [isVerifyCode, setVerifyCode] = useState(false);
  const [email, setEmail] = useState("");
  const inputClass = "border-0 border-b-2 rounded-none";

  const onUpload = async (stateName, { file, onSuccess, onError }) => {
    if (documents[stateName].length == 1) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadDocument(
        file,
        stateName,
        documents[stateName].length + 1,
        1,
        dispatch
      );
      onSuccess();
      setDocuments((prev) => {
        const array = prev[stateName];
        array.push({ name: file.name, url: response.data, status: "done" });
        return {
          ...prev,
          [stateName]: array
        };
      });
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
      console.error(error);
    }
  };

  const CustomLabel = ({ label }) => (
    <span>
      <span style={{ color: "red" }}>*</span> {label}
    </span>
  );
  const handleSentCode = async () => {
    try {
      const userTypeValue = userType;
      await emailotpRequest({ email, userType: userTypeValue });
      setCodeSent(true);
      setVerifyCode(false);
      toast.success("OTP sent to your email");
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
    }
  };
  // const handleVerifyCode = () => {
  //   if (inputCode !== "") {
  //     setVerifyCode(true);
  //   } else {
  //     toast.error("Wrong OTP");
  //   }
  // };
  const handleVerifyCode = async () => {
    try {
      const userTypeValue = userType;
      await verifyOtp({ code: inputCode, email, userType: userTypeValue });
      setVerifyCode(true);
      toast.success("OTP verified successfully");
    } catch (error) {
      toast.error("Wrong OTP, please try again.");
    }
  };
  const handleOtpInput = (e) => {
    setInputCode(e.target.value);
  };

  return (
    <>
      <h3 className="text-2xl font-medium text-[#252525] mb-6 mt-4">
        Basic information
      </h3>
      <Form.Item
        label="Contact Name"
        className="font-normal"
        name="basicInformationContactName"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        rules={[
          {
            required: true,
            message: "Please enter contact name"
          }
        ]}
      >
        <Input className={inputClass} />
      </Form.Item>
      {shortDescription && (
        <div>
          <div className="w-fit">
            <Form.Item
              label={
                <CustomLabel label="A copy of the passport or government-issued identification" />
              }
              rules={[
                {
                  required: true,
                  message: "Please upload government-issued identification"
                }
              ]}
            >
              <Upload
                maxCount={1}
                showUploadList={false}
                customRequest={onUpload.bind(null, "user_goverment_issued_id")}
              >
                <Button
                  varient={"primary"}
                  color={"blue"}
                  className={
                    "px-2 py-1 rounded-[5px] text-xs text-white font-medium flex justify-center gap-x-1 items-center"
                  }
                >
                  <img src={UploadIcon} alt="upload icon" className="w-3" />
                  Upload
                  {loading && <LoadingOutlined className="ml-2" />}
                </Button>
              </Upload>
            </Form.Item>

            {documents["user_goverment_issued_id"].length > 0 && (
              <div className="mb-4 border p-2 rounded-lg">
                {documents["user_goverment_issued_id"].map(
                  ({ name: fileName, url }, index) => (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.2 }}
                      className="group hover:bg-gray-100 px-2 py-1 flex justify-between items-center rounded-md"
                      key={`${"user_goverment_issued_id"}_${index}`}
                    >
                      <span>
                        <FileAddOutlined className="mr-2" />
                        <Link
                          to={url}
                          target="_blank"
                          className="hover:text-blue-800"
                        >
                          {" "}
                          {fileName}
                        </Link>
                      </span>
                      <DeleteOutlined
                        className="hidden group-hover:block cursor-pointer hover:text-blue-800"
                        onClick={() => {
                          const updatedArray =
                            documents["user_goverment_issued_id"];
                          updatedArray.splice(index, 1);
                          setDocuments((prev) => {
                            return {
                              ...prev,
                              user_goverment_issued_id: updatedArray
                            };
                          });
                        }}
                      />
                    </motion.div>
                  )
                )}
              </div>
            )}
          </div>

          <Form.Item label={"Contact details"} labelCol={{ span: 24 }} required>
            <div className="flex mt-2">
              <Form.Item
                className="w-[80px] mr-4"
                initialValue={"91"}
                name={"basicInformationContactDetailsPhoneCode"}
                rules={[
                  {
                    required: true,
                    message: "Please select phone code"
                  }
                ]}
              >
                <Select
                  defaultValue={"91"}
                  className="secondary_variant"
                  suffixIcon={
                    <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                  }
                  placeholder={"Select Code"}
                >
                  {countries.map((ele, index) => (
                    <Select.Option
                      key={`option_${index}`}
                      value={ele.phonecode}
                    >
                      {ele.flag} +{ele.phonecode}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="w-[calc(100%/4)] pr-4"
                name={"basicInformationContactDetailsContactNumber"}
                rules={[
                  {
                    required: true,
                    message: "Please input contact number"
                  },

                  {
                    pattern: /^[0-9]*$/,
                    message: "Please enter a valid contact number"
                  }
                ]}
              >
                <Input placeholder="Contact no." className={inputClass} />
              </Form.Item>
              <Form.Item
                className="w-[calc(100%/4)]"
                name="basicInformationContactDetailsEmail"
                rules={[
                  {
                    type: "email",
                    message: "The input is not a valid email"
                  },
                  {
                    required: true,
                    message: "Please enter your email"
                  }
                ]}
              >
                <Input
                  className={inputClass}
                  type="email"
                  placeholder="Email-id"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>
              <div>
                <Button
                  varient="rounded"
                  borderColor="blue"
                  className={
                    isCodeSent
                      ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                      : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                  }
                  onClick={handleSentCode}
                  disabled={isDisabledForm}
                >
                  {isCodeSent ? "Re-send" : "Send Code"}
                </Button>
              </div>
              <div className="w-24 mr-4">
                <Form.Item
                  name="contactDetailsOtp"
                  rules={[
                    { required: true, message: "Please enter the OTP" },
                    {
                      validator: (_, value) => {
                        if (isVerifyCode === true) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("OTP must be verified")
                        );
                      }
                    }
                  ]}
                >
                  <Input
                    className={inputClass}
                    value={inputCode}
                    onChange={handleOtpInput}
                    type="text"
                    placeholder="OTP"
                    disabled={isVerifyCode}
                  />
                </Form.Item>
                {/* <Input
                  className={inputClass}
                  value={inputCode}
                  onChange={(e) => handleOtpInput(e)}
                  type="text"
                  placeholder="OTP"
                /> */}
              </div>
              <div>
                <Button
                  varient="rounded"
                  className={
                    isVerifyCode
                      ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                      : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                  }
                  onClick={handleVerifyCode}
                >
                  {isVerifyCode ? "Verified" : "Verify"}
                </Button>
              </div>
            </div>
          </Form.Item>
        </div>
      )}
      <SelectAddress
        Country={Country}
        State={State}
        City={City}
        form={form}
        stateName={{
          addressLine: "basicInformationAddressLine",
          country: "basicInformationCountry",
          state: "basicInformationState",
          city: "basicInformationCity",
          pincode: "basicInformationPincode"
        }}
      />

      <Form.Item
        label="Pan ID"
        name="basicInformationPanId"
        rules={[
          {
            required: true,
            message: "Please enter Pan ID"
          }
        ]}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 12 }}
        className="font-normal"
      >
        <Input
          className={`mt-3 ${inputClass}`}
          onChange={(e) => {
            const capitalizedValue = e.target.value.toUpperCase();
            form.setFieldsValue({
              basicInformationPanId: capitalizedValue
            });
          }}
        />
      </Form.Item>
      {userType != "seller" ? (
        <div>
          <p className="text-base text-[#252525] mb-6 mt-4">Registry details</p>
          <RegistryDetails
            registries={registries}
            isDisabledForm={isDisabledForm}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default BasicInformationForm;
